module.exports = __webpack_public_path__ + "img/icon-close.e5e94e06.svg";